import { action, makeAutoObservable, observable } from 'mobx';
import {
  NFC_SUPPORT_TYPE,
  SCAN_COMMAND,
  scanButtonTypes
} from 'modules/scan/types';
import {getTime} from "../../hooks/getTime";

class ScanStore {
  status = null;
  progress_loading_status = null;
  nfc_data = null;
  total_record = 0;
  records_length = 0;
  zero_data = false;
  nfc_support = null;
  device_serialNumber = '';
  correction_date = false;
  device_date = '';
  actionIndex = 0;
  scanButtonStatus = scanButtonTypes.default;
  patientId = null;
  patientName = null;

  constructor() {
    makeAutoObservable(this, {
      status: observable,
      progress_loading_status: observable,
      nfc_data: observable,
      total_record: observable,
      records_length: observable,
      zero_data: observable,
      nfc_support: observable,
      device_serialNumber: observable,
      correction_date: observable,
      device_date: observable,
      actionIndex: observable,
      scanButtonStatus: observable,
      patientId: observable,
      patientName: observable,
      NFC_STARTED_HANDLER: action,
      NFC_DATA_LENGTH_HANDLER: action,
      NFC_READING_STARTED_HANDLER: action,
      NFC_READING_HANDLER: action,
      NFC_FINISHED_OK_HANDLER: action,
      NFC_FINISHED_FAILED_HANDLER: action,
      NFC_DATE_TYPE1_HANDLER: action,
      reset_Scan_Handler: action,
      NFC_SUPPORT_HANDLER: action,
      submitNfcTransaction: action,
      startWebviewConnection: action
    });
  }

  NFC_STARTED_HANDLER() {
    this.status = SCAN_COMMAND.STARTED;
    this.actionIndex = 1;
  }

  NFC_DATA_LENGTH_HANDLER(data) {
    const { length } = data || {};
    const totalLength = length / 8;
    this.status = SCAN_COMMAND.DATA_LENGTH;
    this.total_record = totalLength;
    this.zero_data = totalLength === 0;
    this.actionIndex = 3;
  }

  NFC_READING_STARTED_HANDLER() {
    this.status = SCAN_COMMAND.READING_STARTED;
    this.actionIndex = 4;
  }

  NFC_READING_HANDLER(data) {
    const { length } = data || {};
    this.status = SCAN_COMMAND.READING;
    this.records_length = this.records_length + length / 8;
    this.actionIndex = 5;
  }

  NFC_FINISHED_OK_HANDLER(data) {
    const { data: nfcData } = data;
    const { nozero, hardwareSerialNumber, isok, ndef } =
      JSON.parse(nfcData) || {};
    const validation =
      nozero.length / 8 === this.total_record &&
      hardwareSerialNumber !== SCAN_COMMAND.UNABLE_TO_READ &&
      /^P209[A-Z]{1}[a-zA-Z0-9]{7}$/.test(hardwareSerialNumber);

    const deviceId = ndef.payload.id;

    if (isok && validation && deviceId.length > 0) {
      this.status = SCAN_COMMAND.FINISHED_OK;
      this.actionIndex = 6;
      this.device_serialNumber = hardwareSerialNumber;
      this.nfc_data = nfcData;
    } else {
      this.scanButtonStatus = scanButtonTypes.retry;
      this.status = SCAN_COMMAND.FINISHED_FAILED;
    }
  }

  NFC_FINISHED_FAILED_HANDLER() {
    this.scanButtonStatus = scanButtonTypes.retry;
    this.status = SCAN_COMMAND.FINISHED_FAILED;
  }

  async NFC_DATE_TYPE1_HANDLER(data) {
    const {date} = data || {};
    const deviceTime = new Date(date);
    let serverTime;
    try {
      serverTime = await getTime()
    } catch (error) {
      console.error("Failed to fetch server time:", error);
    }
    const currentTime = serverTime ? new Date(serverTime) : new Date();
    let minutes = Math.abs(currentTime - deviceTime) / (1000 * 60);
    this.device_date = date;
    if (minutes > 5) {
      this.correction_date = true;
    }
  }

  NFC_SUPPORT_HANDLER(event) {
    try {
      const {
        result: { isSupported, isEnabled }
      } = JSON?.parse(event?.data) || {};
      if (!isSupported) {
        this.scanButtonStatus = scanButtonTypes.disabled;
        this.nfc_support = NFC_SUPPORT_TYPE.not_support;
        return;
      }
      if (!isEnabled) {
        this.nfc_support = NFC_SUPPORT_TYPE.disabled;
      }
    } catch (err) {
      console.log(err);
    }
  }

  startWebviewConnection() {
    window?.ReactNativeWebView?.postMessage('scan');
    document?.ReactNativeWebView?.postMessage('scan');
    window?.ReactNativeWebView?.postMessage('startupcheck');
  }

  reset_Scan_Handler(buttonStatus = scanButtonTypes.default) {
    this.status = null;
    this.progress_loading_status = null;
    this.nfc_data = null;
    this.total_record = 0;
    this.records_length = 0;
    this.zero_data = false;
    this.nfc_support = null;
    this.device_serialNumber = '';
    this.correction_date = false;
    this.device_date = '';
    this.actionIndex = 0;
    this.scanButtonStatus = buttonStatus;
    this.patientId = null;
    this.patientName = null;
  }
}

const scanStore = new ScanStore();
export default scanStore;
